module.exports = __webpack_public_path__ + "static/ff-landing-image-header-ACFFlaurel.48ee8349.png";